export function filterIso7010PictogramCodes(
  query: string,
  codes: readonly string[],
  getLabel: (code: string) => string
): string[] {
  const normalized = query.trim().toLowerCase()
  if (normalized.length === 0) {
    return [...codes]
  }
  return codes.filter((code) => {
    const codeLower = code.toLowerCase()
    const labelLower = getLabel(code).toLowerCase()
    return codeLower.includes(normalized) || labelLower.includes(normalized)
  })
}
